import React from "react";
import { ExternalLinkIcon, PhoneLandlineIcon, LetterCloseIcon } from "assets";
import ProfileCard from "pages/Profile/components/ProfileCard";

interface Props {
  isEdit?: boolean;
}

const RepsSection = ({ isEdit }: Props) => {
  return (
    <ProfileCard className="grid grid-cols-1 gap-1 text-s" isEdit={isEdit}>
      <button className="flex items-center gap-2 text-color-brand-one hover:text-white dark:text-blue-aquamarine">
        <h2 className="text-s font-semibold leading-4">Elite Talent Agency</h2>
        <ExternalLinkIcon />
      </button>

      <p className="text-s">456 Broadway, New York, NY 10012</p>

      <div className="flex items-center gap-2 dark:text-white/90">
        <PhoneLandlineIcon className="text-grey-void dark:text-white/90" />
        <span className="text-s">(212) 555-0123</span>
      </div>

      <button className="flex items-center gap-2 text-color-brand-one hover:text-white dark:text-blue-aquamarine">
        <LetterCloseIcon />
        <a href="mailto:s.johnson@elitetalent.com" className="font-medium">
          s.johnson@elitetalent.com
        </a>
      </button>
    </ProfileCard>
  );
};

export default RepsSection;
